// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../../engine/api/http";
import { roles } from "../../../utils/constants";

const initialState = {
  users: [],
  loading: false,
};

export const getUsers = createAsyncThunk(
  "posts/getUsersSearch",
  async thunkAPI => {
    const res = await http.get(`/users/list`);
    return res.data.sort((a, b) =>
      a.info.lastname.localeCompare(b.info.lastname),
    );
  },
);

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    clearUsers: state => {
      return initialState;
    },
  },
  extraReducers: {
    [getUsers.pending]: state => {
      state.loading = true;
    },
    [getUsers.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.users = payload.slice(2);
    },
    [getUsers.rejected]: state => {
      state.loading = false;
    },
  },
});

export const { clearUsers } = usersSlice.actions;

export const usersReducer = usersSlice.reducer;
